export default __webpack_public_path__ + "static/media/tree-testing-icon.2573c94d.svg";